import { lazy, Suspense } from 'react';
import { Loader } from '@/shared/ui';
import type { Props } from './DataTable';

const DataTable = lazy(() =>
  import('./DataTable').then(({ DataTable }) => ({
    default: DataTable,
  })),
);

export function DataTableLazy(props: Props) {
  return (
    <Suspense fallback={<Loader active />}>
      <DataTable {...props} />
    </Suspense>
  );
}
